import React from 'react'
import './ErrorInput.css'

export default function ErrorInput(props) {
    return <>
    <span className="error">{props?.formSubmitted && props.error}</span>
    </>
}